<template>
  <div v-if="showable">
    <b-navbar
      type="dark"
      variant="dark"
      toggleable="md"
    >
      <b-navbar-nav>
        <site-name />
      </b-navbar-nav>

      <b-navbar-toggle target="nav-collapse">
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <login-user-name />

          <icon-members />
          <icon-seating-status />
          <icon-users />
          <icon-settings />
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import SiteName from './SiteName'
import IconMembers from './Icon/Members'
import IconSeatingStatus from './Icon/SeatingStatus'
import IconUsers from './Icon/Users'
import IconSettings from './Icon/Settings'
import LoginUserName from './LoginUserName'

export default {
  components: {
    SiteName,
    IconMembers,
    IconSeatingStatus,
    IconUsers,
    IconSettings,
    LoginUserName
  },

  computed: {
    showable () {
      return this.$store.getters['nav/showable'](this.$route)
    }
  },

  created () {
    this.$store.dispatch(`settings/siteConfig/get`).then(() => {
      this.$store.dispatch(`settings/siteConfig/set`)
    })
  }
}
</script>
